import React from 'react';
// import PropTypes from 'prop-types';
import { FloatingActionButton } from 'appkit-react';

// import '@style/components/settingBtn.scss';
import '../styles/components/settingBtn.scss';

function ActionBtn(props) {
  const { onMouseEnter = () => {} } = props;
  return (
    <FloatingActionButton
      className="more-action-btn"
      size="sm"
      onMouseEnter={onMouseEnter}
    >
      <span className="appkiticon icon-vertical-more-fill a-font-20" />
    </FloatingActionButton>
  );
}

export default ActionBtn;
